<template>
  <form action="" method="post" novalidate="true">
    <div
      class="app-field"
      v-test="{ id: 'urlParent' }"
      :class="{ 'app-field--error': errors.length && submitted }"
    >
    <label>
      <input
        aria-label="url"
        id="url"
        name="url"
        type="text"
        placeholder="www.example.com"
        @blur="cleanAndCheckUrl"
        v-test="{ id: 'url' }"
        v-model="url"
      >
      </label>
    </div>

    <app-btn
      text="sift"
      :class="{ 'app-btn--error': errors.length && submitted }"
      :loading="isSifting"
      @click.native.prevent="processForm"
      v-test="{ id: 'submit' }"
    />

    <portal to="load-meta" v-if="!isSifting && linksCount >= 0">
      <a href="" @click.prevent="scrollToResults" class="app-field__arrow"></a>
    </portal>

    <portal to="modals">
      <app-modal v-if="hasTimedOut" @close="handleTimeout">
        Unfortunately, the request has timed out.
      </app-modal>
    </portal>
  </form>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapMutations, mapGetters } from 'vuex';
import Test from '@/directives/test';
import UrlInputProxy from '@/components/Hero/UrlInput/UrlInputProxy';
import eventBus from '@/event-bus';
import Button from '@/components/UI/Button.vue';
import Modal from '@/components/UI/Modal.vue';

export default {
  name: 'UrlInput',
  directives: { Test },
  components: {
    appBtn: Button,
    appModal: Modal,
  },
  data: function () {
    return {
      submitted: false,
      errors: [],
      url: null,
      links: [],
      debouncedProcessForm: null,
      hasTimedOut: false,
    };
  },
  created() {
    eventBus.$on('tryAgain', () => {
      this.url = '';
    });

    eventBus.$on('siftAgain', (website) => {
      this.url = website;
      this.processForm();
    });
  },
  mounted() {
    this.debouncedProcessForm = debounce(function () {
      this.getData();
    }, 250);
  },
  computed: {
    ...mapGetters({
      isSifting: 'UrlInput/isBeingSifted',
      linksCount: 'UrlInput/siftedWebsiteLinksCount',
    }),
  },
  methods: {
    ...mapMutations({
      setSiftedWebsite: 'UrlInput/setSiftedWebsite',
      clearLinks: 'UrlInput/clearLinks',
      setSiftingStatus: 'UrlInput/setSiftingStatus',
    }),
    handleTimeout() {
      this.errors = [];
      this.hasTimedOut = false;
    },
    processForm() {
      if (this.validateForm()) {
        this.url = this.url.toLowerCase();
        this.debouncedProcessForm();
      }
    },
    validateForm() {
      this.submitted = true;
      this.errors = [];

      if (!this.url) {
        this.errors.push('Url required.');
      }

      if (this.url && !this.url.includes('.')) {
        this.errors.push('Invalid Url');
      }

      return !this.errors.length;
    },
    cleanAndCheckUrl() {
      this.url = this.removeProtocol(this.url);
      this.url = this.url.toLowerCase();
      this.validateForm();
    },
    removeProtocol(url) {
      return url.includes('://') ? url.split('://').pop().trim() : url;
    },
    getData() {
      if (this.errors.length === 0 && this.submitted) {
        this.setSiftingStatus(true);

        UrlInputProxy(this.url)
          .then((data) => {
            if (data && data.website) {
              this.setSiftedWebsite(data.website);
              eventBus.$emit('showSiftResults');
            } else if (data && !data.website) {
              eventBus.$emit('error404');
              this.clearLinks();
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.code === 'ECONNABORTED') {
              this.errors.push('timeout');
              this.hasTimedOut = true;
              this.clearLinks();
              eventBus.$emit('showSiftResults');
            }
          }).finally(() => {
            this.setSiftingStatus(false);
            eventBus.$emit('stoppedSifting');
          });
      }
    },
    scrollToResults() {
      const results = document.querySelector('.sift-links-wrap');
      this.$smoothScroll({ scrollTo: results, offset: -73 });
    },
  },
};
</script>
